import { ROOT_URL } from '../actions';

export const reportsApi = {
  DOWNLOAD_NO_DATA_SCAN: `${ROOT_URL}/hms/download-nodata-scan/`,
  DOWNLOAD_DELIVERY_MANIFEST: `${ROOT_URL}/hms/download-delivery-manifest/`,
  GET_ALL_HUBS: `${ROOT_URL}/hms/hubs/`
}